export const LogisticStatusEnum = Object.freeze({
    1: 'ETA at Carzelle',
    2: 'Checked In',
    3: 'Checked Out',
    4: 'ETA at Destination',
});


